import { useMemo } from "react";

import AdsClickRoundedIcon from "@mui/icons-material/AdsClickRounded";
import EmojiEventsRoundedIcon from "@mui/icons-material/EmojiEventsRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import MarkChatReadRoundedIcon from "@mui/icons-material/MarkChatReadRounded";
import MarkEmailReadRoundedIcon from "@mui/icons-material/MarkEmailReadRounded";
import RemoveCircleRoundedIcon from "@mui/icons-material/RemoveCircleRounded";

import { EmailType } from "@interfaces/campaign.type";

const useCounts = (emails: EmailType[]) => {
  return useMemo(() => {
    const counts = {
      allContacts: emails?.length,
      bounced: 0,
      clicked: 0,
      leads: 0,
      opened: 0,
      responded: 0,
    };

    if (emails)
      for (const email of emails) {
        if (email.status.opened) counts.opened++;
        if (email.status.clicked) counts.clicked++;
        if (email.status.responded) counts.responded++;
        if (email.status.lead) counts.leads++;
        if (email.status.bounced) counts.bounced++;
      }

    return [
      { count: counts.allContacts, icon: <GroupsRoundedIcon />, key: "all", text: "All Contacts" },
      { count: counts.opened, icon: <MarkEmailReadRoundedIcon />, key: "opened", text: "Opened" },
      { count: counts.clicked, icon: <AdsClickRoundedIcon />, key: "clicked", text: "Clicked" },
      { count: counts.responded, icon: <MarkChatReadRoundedIcon />, key: "responded", text: "Responded" },
      { count: counts.leads, icon: <EmojiEventsRoundedIcon />, key: "leads", text: "Leads" },
      { count: counts.bounced, icon: <RemoveCircleRoundedIcon />, key: "bounced", text: "Bounced" },
    ];
  }, [emails]);
};

export default useCounts;
